<template>
  <div>
    <v-container
      v-if="
        person.目前狀態.我目前有嚼食檳榔的習慣 ||
        person.目前狀態.我過去曾經有嚼食檳榔的習慣 ||
        person.目前狀態.我目前有吸菸的習慣 ||
        person.目前狀態.我過去曾經有吸菸的習慣
      "
    >
      <v-row class="mt-1">
        <v-col
          class="pa-0"
          cols="12"
          sm="6"
          v-if="
            person.目前狀態.我目前有嚼食檳榔的習慣 ||
            person.目前狀態.我過去曾經有嚼食檳榔的習慣
          "
        >
          <div class="text-h5 font-weight-bold">個人檳榔史</div>
          <div class="mt-2">
            <div class="font-weight-bold">每天嚼食檳榔量</div>
            <div class="mt-2">
              <v-radio-group
                class="mt-0 pt-0"
                v-model="問卷.每日檳榔量"
                :rules="[(v) => !!v || '此為必填欄位']"
                row
              >
                <v-radio
                  class="item-width"
                  v-for="key in ['少於20顆', '20顆以上']"
                  :key="key"
                  :label="key"
                  :value="key"
                ></v-radio>
              </v-radio-group>
            </div>
            <div class="font-weight-bold">嚼食檳榔年資</div>
            <div class="mt-2">
              <v-radio-group
                class="mt-0 pt-0"
                v-model="問卷.檳榔年資"
                :rules="[(v) => !!v || '此為必填欄位']"
                row
              >
                <v-radio
                  class="item-width"
                  v-for="key in ['少於10年', '10年以上']"
                  :key="key"
                  :label="key"
                  :value="key"
                ></v-radio>
              </v-radio-group>
            </div>
          </div>
        </v-col>
        <v-col
          class="pa-0"
          cols="12"
          sm="6"
          v-if="person.目前狀態.我目前有吸菸的習慣"
        >
          <div class="text-h5 font-weight-bold">個人吸菸史</div>
          <div class="mt-2">
            <div class="font-weight-bold">每天吸菸量</div>
            <div class="mt-2">
              <v-radio-group
                class="mt-0 pt-0"
                v-model="問卷.每天吸菸量"
                :rules="[(v) => !!v || '此為必填欄位']"
                row
              >
                <v-radio
                  class="item-width"
                  v-for="key in ['少於20支', '20支以上']"
                  :key="key"
                  :label="key"
                  :value="key"
                ></v-radio>
              </v-radio-group>
            </div>
            <div class="font-weight-bold">吸菸年資</div>
            <div class="mt-2">
              <v-radio-group
                class="mt-0 pt-0"
                v-model="問卷.吸菸年資"
                :rules="[(v) => !!v || '此為必填欄位']"
                row
              >
                <v-radio
                  class="item-width"
                  v-for="key in ['少於10年', '10年以上']"
                  :key="key"
                  :label="key"
                  :value="key"
                ></v-radio>
              </v-radio-group>
            </div>
          </div>
        </v-col>
      </v-row>
    </v-container>
    <v-container>
      <v-row class="mt-1">
        <v-col class="pa-0" cols="12" sm="6">
          <div class="text-h5 font-weight-bold">口腔自我評估</div>
          <div class="mt-2">
            <div class="font-weight-bold max-width">
              自覺口腔黏膜有無異常狀況？如異常顏色斑塊、口腔黏膜疼痛、難癒合之潰瘍及腫塊症狀
            </div>
            <div class="mt-2">
              <v-radio-group
                class="mt-0 pt-0"
                v-model="問卷.口腔自覺異狀"
                :rules="[(v) => !!v || '此為必填欄位']"
                row
              >
                <v-radio
                  class="item-width"
                  v-for="key in ['無', '有']"
                  :key="key"
                  :label="key"
                  :value="key"
                ></v-radio>
              </v-radio-group>
            </div>
          </div>
        </v-col>
        <v-col class="pa-0" cols="12" sm="6">
          <div class="text-h5 font-weight-bold">腸胃自我評估</div>
          <div class="mt-2">
            <div class="font-weight-bold max-width">
              請問您有無腸道不適症狀？如腹瀉、便秘、糞便變稠、排泄黏液、便血或黃便帶等
            </div>
            <div class="mt-2">
              <v-radio-group
                class="mt-0 pt-0"
                v-model="問卷.腸胃自覺異狀"
                :rules="[(v) => !!v || '此為必填欄位']"
                row
              >
                <v-radio
                  class="item-width"
                  v-for="key in ['無', '有']"
                  :key="key"
                  :label="key"
                  :value="key"
                ></v-radio>
              </v-radio-group>
            </div>
          </div>
        </v-col>
      </v-row>
    </v-container>
    <v-container>
      <div class="text-h5 font-weight-bold">個人教育程度</div>
      <div class="d-flex flex-wrap">
        <v-radio-group
          class="mt-1 pt-0"
          v-model="問卷.教育程度"
          :rules="[(v) => !!v || '此為必填欄位']"
          row
        >
          <v-radio
            class="item-width my-1"
            v-for="key in 教育程度"
            :key="key"
            :label="key"
            :value="key"
          ></v-radio>
        </v-radio-group>
      </div>
    </v-container>
  </div>
</template>

<script>
import { 教育程度 } from "@/libs/const.js";
export default {
  name: "QuestionContent",
  props: ["valid", "person", "問卷"],
  data: () => ({
    教育程度,
  }),
};
</script>
<style lang="scss" scoped>
.item-width {
  width: 120px;
}
.max-width {
  max-width: 400px;
}
</style>
